import clock from "./clock";
import display from "./display";
import { Handler } from "./handler";
import scoreboard from "./scoreboard";
import { buzzerSound } from "./sound";
import { clockString } from "./util";

const timeouts = {
    home: {
        full: 1,
        partial: 0,
    },
    guest: {
        full: 1,
        partial: 0,
    },
};

export class TeamTimeOut extends Handler {
    constructor(private side: "home" | "guest") {
        super();
    }

    boot() {
        display.line1(`TIME OUTS-${this.side.toUpperCase()}`);

        if (timeouts[this.side].full == 0) {
            display.line2("NO TIME OUTS");
            clock.displayTimeAndScoreAfter1Second();
            clock.popHandler();
        } else {
            display.line2(`FULL        ${timeouts[this.side].full--}`);
        }
    }

    onEnter() {
        clock.setHandler(new TimeoutRunning(this.side.toUpperCase(), 60000));
    }

    onClear() {
        clock.popHandler();
    }
}

export class SelectTimeOut extends Handler {
    private full: boolean;

    constructor() {
        super();
        this.full = true;
    }

    boot() {
        display.line1("TIME OUTS-SELECT");
        this.displayFullPartial();
    }

    displayFullPartial() {
        if (this.full) display.line2("FULL     •1:00");
        else display.line2("PARTIAL  •0:20");
    }

    onTimeoutOnOff() {
        this.full = !this.full;
        this.displayFullPartial();
    }

    onEnter() {
        clock.setHandler(new TimeoutRunning("", this.full ? 60000 : 20000));
    }

    onClear() {
        clock.popHandler();
    }
}

export class TimeoutRunning extends Handler {
    private timer: number | undefined;
    private side: string;
    private clock: number;

    constructor(side: string, clock: number) {
        super();

        this.side = side;
        this.clock = clock;
    }

    boot() {
        clock.displayScore();
        this.displayTime();

        this.timer = setInterval(() => {
            this.clock -= 1000;
            this.displayTime();
            if (this.clock <= 0) {
                this.stopAndExit();
                buzzerSound.playFor(1500);
            }
        }, 1000);
    }

    stopAndExit() {
        clearInterval(this.timer);
        this.timer = undefined;

        display.line1(`TIME OUTS-${this.side.toUpperCase()}`);
        display.line2("OFF");

        clock.displayTimeAndScoreAfter1Second();
        clock.popHandler();
    }

    displayTime() {
        const timeString = clockString(this.clock, { leftTrim: " " });
        display.line1(`T.O.  ${timeString}    v`);
        scoreboard.setMainClockVal(this.clock);
    }

    onTimeoutHome() {
        this.stopAndExit();
    }

    onTimeoutGuest() {
        this.stopAndExit();
    }

    onTimeoutOnOff() {
        this.stopAndExit();
    }
}
